<div id="virtual-sessions-container" class="container">

    <h1 jhitranslate="sessions.title"><i class="fa fa-bookmark-o fa-pre fa-pre" aria-hidden="true"></i> Recherches de
        formateur</h1>

    <button class="btn btn-primary btn-round btn-lg" uiSref="session-staffing-create"> +</button>

    <div class="filters-parent">
        <div class="filters">
            <label class="control-label" for="search">Rechercher</label>
            <input class="form-control input-filter" id="search" type="text" [(ngModel)]="search"
                   placeholder="Filtrer sujet, date estimé ou par message" #searchInput>
            <div (click)="archivedClicked()" class="active-filter">Archivé :
                <span *ngIf="archived"><i class="fa fa-check-circle" aria-hidden="true"></i></span>
                <span *ngIf="!archived"><i class="fa fa-circle-thin" aria-hidden="true"></i></span>
            </div>
        </div>
    </div>

    <div
            *ngFor="let viewVirtualSessions of [((virtualSessions | sessionStaffingFilterByArchived:archived) | sessionStaffingFilterBySearch:search)]">
        <h2 *ngIf="viewVirtualSessions && !viewVirtualSessions.length">Aucune recherche de formateur</h2>
        <div class="table-responsive" *ngIf="viewVirtualSessions && viewVirtualSessions.length">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th>Sujet</th>
                    <th style="min-width: 130px">Date estimé</th>
                    <th style="min-width: 130px">Message</th>
                    <th style="min-width: 70px;max-width: 70px">Création</th>
                    <th style="min-width: 35px;max-width: 55px;">Archivée</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let virtualSession of viewVirtualSessions"
                    uiSref="session-staffing-detail"
                    [uiParams]="{ id: virtualSession.id }">
                    <td>{{virtualSession.title}}</td>
                    <td>{{virtualSession.estimationDate}}</td>
                    <td>{{virtualSession.message}}</td>
                    <td>{{virtualSession.creationDate | formatdatepipe}}</td>
                    <td *ngIf="virtualSession.archived"><i class="fa fa-check-circle" aria-hidden="true"></i></td>
                    <td *ngIf="!virtualSession.archived"><i class="fa fa-circle-thin" aria-hidden="true"></i></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/staffing.component.html